import { Box, Typography } from "@mui/material"

export function FeaturePackEmptyPreview() {
    return (
        <Box sx={{ p: 2, color: "text.disabled" }}>
            <Typography variant="body2">Choose a feature pack to preview its changes.</Typography>
        </Box>
    )
}
